<template>
    <div>
        <Header />
        <v-dialog persistent content-class="innerExPan" v-model="Loaderdialog"  id="innerExPan" >
                <v-row no-gutters>
                  <v-col cols="12" sm="12" style="text-align:center">
                    <img  :src="require('@/assets/images/loader.svg')"  />
                  </v-col>
                </v-row>
              </v-dialog>
          
    <v-card-text style="font-size:0.8rem !important;">
         
         <v-col cols="12">
           <v-card
             color="#fff"
             theme="light"
             style="margin-top:5px;"
           >
           <v-dialog v-model="DateModal" max-width="500px">
             <v-card>
               <v-card-text style="padding-top:2em;">
                 <v-text-field label="Select Date"
                 v-model="AsOnDate"
                 required
                 dense 
                 type="date">
               </v-text-field>
               <!-- <v-combobox
               v-show="notmorethan1"
               v-model="selected_branch"
               label="Select Branch"
               :items="branches"
               dense
              ></v-combobox> -->
              <v-combobox
              v-model="BranchCode"
                  :items="BranchCodeOptions"
                 label="Select Branch"
                 :disabled="IsDisableBarnch"
             
                 dense
              ></v-combobox>
              <!-- <v-text-field 
             disabled
              v-show="!notmorethan1"
              v-model="selected_branch"
              label="Select Branch"
              >
   
              </v-text-field> -->
              
   
                
               </v-card-text>
   
               <v-card-actions>
                 <v-spacer></v-spacer>
   
                 <v-btn text color="primary" @click="GetAllSaleSummary()">ok</v-btn>
               </v-card-actions>
             </v-card>
           </v-dialog>
           <v-card-text style="height: 20px; position: relative">
             <v-btn
               absolute
               dark
               fab
               top
               right
               color="blue"
               @click="DateModal = !DateModal"
             >
               <v-icon>mdi-calendar</v-icon>
             </v-btn>
           </v-card-text>
           <v-card-subtitle style="color:#000;padding-bottom: 0px;padding-top: 0px;text-align:center;">
             <i class="fa fa-calendar"></i> &nbsp; {{ AsOnDate }}
            </v-card-subtitle>
             <div class="d-flex flex-no-wrap justify-space-between">
               <div style="width: 100%;text-align:center;">
               <v-avatar
               class="ma-3"
               size="115"
               rounded="0"
             >
             
               <!-- <v-img :src="require('@/assets/images/bg.png')"></v-img> -->
               <v-img src="https://static.vecteezy.com/system/resources/thumbnails/001/830/448/small/counter-with-cash-register-seller-old-man-and-woman-design-free-vector.jpg"></v-img>
             </v-avatar>
          
            
           </div>
           
             </div>
             <div class="d-flex flex-no-wrap justify-space-between">
              
               <div style="width: 100%;text-align:left;">
                 
                 <v-card-subtitle style="color:#000;">
                   <v-col style="font-size:0.6rem; color:#000;padding-left:0px;padding-bottom: 0px;">Other Details</v-col>
                   <hr>
                   <v-row no-gutters>
                    
                     <v-col cols="5" style="font-size:0.6rem; color:#000;font-weight:800;">
                      
                        Total Tax<br>
                        Discount<br>
                        Round Off<br>
                        Sales Return
                        
                       
                     </v-col>
                     <v-col cols="7" style="text-align:right">
                       <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.tax)}}</b><br>
                       <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.discount)}}</b><br>
                       <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.roundOff)}}</b><br>
                       <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.saleReturn)}}</b><br>
                       
                     </v-col>
                   </v-row>
                  </v-card-subtitle>
               
                
   
                 <v-card-actions style="text-align:right;float:right; color:#000;">
                 
                 <!-- //here total   -->
                 </v-card-actions>
               </div>
               <div style="width: 100%;text-align:right;">
                 
                 <v-card-subtitle style="color:#000;">
                   <v-col style="font-size:0.6rem; color:#000;padding-left:0px;padding-bottom: 0px;text-align:right;">Sale Details</v-col>
                   <hr>
                   <v-row no-gutters>
                     <v-col cols="4" style="font-size:0.6rem; color:#000;font-weight:800;">
                      
                       Cash<br>
                       Credit<br>
                       Digital pay<br>
                       Others
                       <!-- Discount<br>
                       Tax<br>
                       Round Off -->
                      
                    </v-col>
                    <v-col cols="8">
                      <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.cash )}}</b><br>
                      <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.credit)}}</b><br>
                      <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.creditCard)}}</b><br>
                      <b style="color:#000;">{{FormatewithDecimalPlacesNew(SalesData.others)}}</b>
                      <!-- <b style="color:#000;">(-){{formatPrice(counteritem.discount )}}</b><br>
                      <b style="color:#000;">{{formatPrice(counteritem.tax )}}</b><br>
                      <b style="color:#000;">(-){{formatPrice(counteritem.roundOff )}}</b> -->
                    </v-col>
                   </v-row>
                  </v-card-subtitle>
                 
                
                 <hr style="    margin-left: 15px;">
                 <v-card-actions style="text-align:right;float:right; color:#000;padding-top:0px">
                 
                   Total : &nbsp;<b>{{FormatewithDecimalPlacesNew(  SalesData.totSale  - (SalesData.paidAmt + SalesData.roundOff ))}}</b> 
                  
                 </v-card-actions>
               </div>
             
   
              
             </div>
            
           </v-card>
           
         </v-col>
       </v-card-text>
    
   
            
    </div>
  </template>
  <script>
  import Header from "../Pages/Header.vue";
  import axios from "axios";
  export default {
    components: {
      Header
    },
    data() {
      return {
        show: false,
        DateModal:false,
         check_date:null,
         Loaderdialog:false,
         bURL : localStorage.getItem('BaseURL'),
         SalesData:{
          "cash" : 0,
          "credit" : 0,
          "creditCard" :0,
          "others" :0,
          "tax" : 0,
          "discount" : 0,
          "roundOff" : 0,
          "saleReturn" : 0,
          "openingAmt" : 0,
          "paidAmt" : 0
         },
         AsOnDate:new Date().toISOString().substr(0, 10),
         BranchCodeOptions:JSON.parse(localStorage.getItem('Branches')),
         BranchCode:"",
         IsDisableBarnch : false,

   
      };
    },
    mounted() {
    
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        let yyyy = today.getFullYear();

        // today = yyyy + '-' + mm + '-' + '21';//dd ;
        today = yyyy + '-' + mm + '-' + dd ;
        this.TodayDate = today
        this.check_date = today;
        this.UserDetails = JSON.parse(localStorage.getItem('User'))
        this.BranchCode = this.UserDetails.branchCode
        if(this.BranchCode === "#" || this.BranchCode === "" || this.BranchCode === "null" || this.BranchCode === null)
        {
          this.BranchCode = "All"
        }
        else if(this.UserDetails.userType !== "Administrator")
        {
          this.IsDisableBarnch = true
        }

       if(this.BranchCode !== "")
          this.GetAllSaleSummary()


    },
    methods: {
    
      GetAllSaleSummary()
      {
        //axios.get(this.bURL + "/api/counter/GetCounterSaleSummary?ForDate="+this.AsOnDate+"&BranchCode="+this.BranchCode+"&WithSummary=true")
        axios.get(this.bURL + "/api/counter/GetAllSaleSummary?ForDate="+this.AsOnDate+"&BranchCode="+this.BranchCode)
        .then(
            (response) => {
              this.SalesData = response.data.result[0]
              this.DateModal = false
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
      },
      FormatewithDecimalPlacesNew(value) {
        this.number = localStorage.getItem("symbol");
        //let val = (value / 1).toFixed(this.number).replace(".", ".");
        //return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        value = parseFloat(value);
        if(isNaN(value)  === true)
        {
          value = 0
        }
        return value.toFixed(this.number);
      
    },
    }
  };
  </script>
  